import { useMemo } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { DistributionUICustomization } from "@searchui-searchforms/shared/customization";
import { useUICustomization } from "@/shared/ui-customization";
import { getButtonWidthClass } from "../sharedCustomizations/getButtonWidthClass";

const BUTTON_SIZE_MAP: Record<NonNullable<DistributionUICustomization["submitButtonSize"]>, string> = {
    sm: "sml",
    lrg: "lrg",
    lrgr: "lrgr",
};

const BUTTON_COLOUR_MAP: Record<NonNullable<DistributionUICustomization["submitButtonColor"]>, string> = {
    silver: "silver",
    // Yes, that's intended. For some reason core.css class for
    // green button is "blue"
    green: "blue",
};

interface SubmitProps {
    isSubmitting?: boolean;
    disabled?: boolean;
    label?: string;
}

const Submit = ({ isSubmitting, disabled, label }: SubmitProps) => {
    const { t } = useTranslation();
    const { submitButtonText, submitButtonSize, submitButtonColor, controlButtonsWidth } = useUICustomization();

    const btnClassName = useMemo(
        () =>
            classNames(
                "ancBtn",
                submitButtonColor && BUTTON_COLOUR_MAP[submitButtonColor],
                submitButtonSize && BUTTON_SIZE_MAP[submitButtonSize],
                getButtonWidthClass(controlButtonsWidth),
            ),
        [submitButtonColor, submitButtonSize, controlButtonsWidth],
    );

    const submitLabel = submitButtonText || label || t("searchForm.submit");

    return (
        <button
            className={classNames(btnClassName, { disabled })}
            type="submit"
            disabled={disabled}
            data-testid="submit-form"
        >
            {isSubmitting ? t("searchForm.searching") : submitLabel}
        </button>
    );
};
export { Submit };
